import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import clientEmployees from "../../../assets/onboarding-completed/client-employees.png";
import clientPartners from "../../../assets/onboarding-completed/client-partners.png";
import expeditorFleet from "../../../assets/onboarding-completed/expeditor-fleet.png";
import expeditorDrivers from "../../../assets/onboarding-completed/expeditor-drivers.png";
import style from "./CompletedOnboarding.module.scss";

const cardsByRole = {
  client: [
    {
      key: "partners",
      image: clientPartners,
      href: "/partners",
      tone: "green",
    },
    {
      key: "employees",
      image: clientEmployees,
      href: "/workers/create",
      tone: "purple",
    },
  ],
  expeditor: [
    {
      key: "employees",
      image: clientEmployees,
      href: "/workers/create",
      tone: "purple",
    },
    {
      key: "fleet",
      image: expeditorFleet,
      href: "/cars/create",
      tone: "blue",
    },
    {
      key: "drivers",
      image: expeditorDrivers,
      href: "/drivers/create",
      tone: "green",
    },
  ],
};

const CompletedOnboarding = ({ role = "client" }) => {
  const { t } = useTranslation();
  const cards = cardsByRole[role] || cardsByRole.client;

  return (
    <main className={style.page}>
      <header className={style.header}>
        <h1 className={style.title}>{t("onboardingComplete.title")}</h1>
        <p className={style.description}>{t("onboardingComplete.description")}</p>
      </header>

      <div className={style.cards}>
        {cards.map(({ key, image, href, tone }) => {
          const translationKey = `onboardingComplete.${key}`;

          return (
            <article className={style.card} key={key}>
              <div className={style.illustration}>
                <img src={image} alt="" />
              </div>

              <div className={style.cardContent}>
                <div className={style.cardCopy}>
                  <h2 className={style.cardTitle}>{t(`${translationKey}.title`)}</h2>
                  <p className={style.cardDescription}>{t(`${translationKey}.description`)}</p>
                </div>
                <Link className={`${style.action} ${style[tone]}`} to={href}>
                  {t(`${translationKey}.button`)}
                </Link>
              </div>
            </article>
          );
        })}
      </div>
    </main>
  );
};

export default CompletedOnboarding;
